<template>
	
	<div class="card comment">
		
		<!-- Profile Picture -->
		
		<div class="comment__profile-picture">
			<ion-icon name="person"></ion-icon>
		</div>
		
		<!-- Delete Button? -->
		
		<ion-icon v-if="$auth.check('admin')" name="trash" class="comment__delete-button" @click.prevent="onClickDeleteComment"/></i>
		
		<!-- Comment -->
		
		<div class="comment__text-wrapper">
			<h4 class="comment__name">{{ comment.user.name }}</h4>
			<p class="comment__timestamp">{{ comment.created_at | commentTimestamp }}</p>
			<p class="comment__text" v-linkify>{{ comment.text }}</p>
		</div>
		
	</div>
	
</template>

<script>
	
	//import axios from "axios";
	
	export default {
		
		props: {
			ticket_id: { default: 0 },
			comment: { default: {} },
		},
		
		methods: {
			
			onClickDeleteComment() {
				
				this.$confirm("Are you sure you want to delete this comment? This action cannot be undone.", "Please Confirm", {
					confirmButtonText: "Delete",
					confirmButtonClass: "el-button--danger",
					cancelButtonText: "Cancel",
				}).then(() => {
					var comment_id = this.comment.id;
					this.axios.delete(`comments/${comment_id}`, {
						params: { ticket_id: this.ticket_id },
					}).then((response) => {
						// Message.
						this.$store.commit("setLoading", { type: "finish", message: "That comment has been deleted." });
						// Emit event.
						this.$emit("on-delete", { error: false, success: true, axios: response, comment_id: comment_id });
					}).catch((response) => {
						// Message.
						this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while deleting that comment." });
						// Emit event.
						this.$emit("on-delete", { error: true, success: false, axios: response, comment_id: comment_id });
					});
				}).catch(() => {
					
				});
				
			},
			
		},
		
	}
	
</script>

<style>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Comments/Comment.vue